import {
  type SelectOption,
  type SelectOptionType,
  isNestedOption,
} from 'components/Select/SelectOption';
import { escapeRegExp } from 'utils/escapeRegExp';

export function filterSelectOptions<TValue>(
  // overload for flat options
  options: SelectOptionType<TValue>[],
  searchValue: string,
): SelectOptionType<TValue>[];
export function filterSelectOptions<TValue>(
  // overload for nested options
  options: SelectOption<TValue>[],
  searchValue: string,
): SelectOption<TValue>[];
// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
export function filterSelectOptions<TValue>(
  options: SelectOption<TValue>[],
  searchValue: string,
): SelectOption<TValue>[] {
  const regExpStart = new RegExp(`^${escapeRegExp(searchValue)}`, 'i');
  const regExpMiddle = new RegExp(`.${escapeRegExp(searchValue)}`, 'i');

  const matchesStart: SelectOption<TValue>[] = [];
  const matchesMiddle: SelectOption<TValue>[] = [];

  for (const option of options) {
    if (isNestedOption(option)) {
      const nestedMatchesStart: SelectOptionType<TValue>[] = [];
      const nestedMatchesMiddle: SelectOptionType<TValue>[] = [];
      for (const nestedOption of option.options) {
        if (regExpStart.test(nestedOption.label)) {
          nestedMatchesStart.push(nestedOption);
        } else if (regExpMiddle.test(nestedOption.label)) {
          nestedMatchesMiddle.push(nestedOption);
        }
      }

      if (nestedMatchesStart.length > 0) {
        matchesStart.push({
          ...option,
          options: [...nestedMatchesStart, ...nestedMatchesMiddle],
        });
      } else if (nestedMatchesMiddle.length > 0) {
        matchesMiddle.push({
          ...option,
          options: nestedMatchesMiddle,
        });
      }
    } else if (regExpStart.test(option.label)) {
      matchesStart.push(option);
    } else if (regExpMiddle.test(option.label)) {
      matchesMiddle.push(option);
    }
  }

  return [...matchesStart, ...matchesMiddle];
}
